export enum SECTOR_NAME {
  BAR = "bar",
  CAFE = "cafe",
  RESTAURANT = "restaurant",
  HOTEL = "hotel",
  SHOP = "shop",
  PARK = "park",
  WELLNESS = "wellness",
  OTHER = "other",
}
